export const GET_CHATBOT_IFRAME = 'api/chatbot/get-iframe-url';
export const GET_CHATBOT_IFRAME_GUEST = 'api/chatbot/get-iframe-url-for-guest';